module.exports = __webpack_public_path__ + "img/printer.4ec01d41.svg";